var map = {
	"./facebook.svg": "ea23",
	"./globe.svg": "bf69",
	"./instagram.svg": "eb1f",
	"./linkedin.svg": "1166",
	"./twitter.svg": "2380",
	"./youtube.svg": "0aab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "197d";